import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import MainSideColumn from "../../Components/sidebars/MainSideColumn";
import { useNavigate } from "react-router-dom";
import { hide } from "../../redux/SideBarSlice";
import { DIRECT_CARDS, SOLUTIONS } from "./constant";
import RightContentColumn from "../../Components/sidebars/RightContentColumn ";


const Solutions = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const navigate = useNavigate();
  const visible = useSelector((state) => state.sidebarItem.visible);
  const source = useSelector((state) => state.sidebarItem.source);
  console.log("Redux state:", { visible, source });
  const dispatch = useDispatch()

  function handleProductClick(index) {
    setActiveIndex(index);
    dispatch(hide())
    navigate(SOLUTIONS[index].path);
  }

  const state = useSelector((state) => state.sidebarItem);
  console.log("Current state:", state);

  return (
    <>
      {visible && source === "solutions" && (
        <div className="product-container">
          <MainSideColumn
            products={SOLUTIONS}
            activeIndex={activeIndex}
            onProductClick={handleProductClick}
            title="Products"
          />

          {/* RIGHT – Cards */}
          <RightContentColumn cards={DIRECT_CARDS} />
        </div>
      )}

    </>
  );
};

export default Solutions;
